import {
  PaymentChannelLiteModel,
  useGetPaymentChannels,
} from 'api-hooks/payment-channel';
import { NavigationRoutes } from 'common/constants';
import { CommissionFilterStatusEnum } from 'common/constants/enum';
import { IColumn } from 'components/elements/table-component/table-component';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import UniskaiStatusBadges from 'templates/form/uniskai-status-badges';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function PaymentChannelList() {
  const { t } = useTranslation();
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);

  const columns = React.useMemo<IColumn<PaymentChannelLiteModel>[]>(
    () => [
      {
        header: t('common:name'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
      {
        header: t('common:description'),
        accessorKey: 'description',
        minSize: 500,
        sortName: 'description',
      },
      {
        header: t('common:status'),
        accessorKey: 'isActive',
        minSize: 100,
        sortName: 'is_active',
        cell: ({ row }) => {
          return (
            <UniskaiStatusBadges
              status={
                row.original.isActive
                  ? CommissionFilterStatusEnum.Active
                  : CommissionFilterStatusEnum.Inactive
              }
            />
          );
        },
      },
    ],
    [t],
  );

  const permission = useGetCrudPermission('payment-channels');

  return (
    <UniskaiListTemplate
      title={t(`pathname:${NavigationRoutes.PaymentChannelsList}`)}
      addNavigation={NavigationRoutes.PaymentChannelsCreate}
      showAdd={permission.create}
      columns={columns}
      useQuery={useGetPaymentChannels}
      page={page}
      setPage={setPage}
      tableName={NavigationRoutes.PaymentChannelsList}
      queryInput={{
        params: {
          page,
        },
      }}
      rowLink={
        permission.view
          ? (row) => ({
              pathname: NavigationRoutes.PaymentChannelsView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
